<template>
  <div>
    <div v-if="media.type === 'folder'" role="button" class="card-img-top text-primary py-2 d-flex align-items-center justify-content-center">
      <i :class="'fas fa-' + size + 'x ' + getMediaThumbnail()" style="visibility: hidden;"></i>
    </div>

    <div v-if="media.type === 'file'" role="button" class="card-img-top d-flex align-items-center justify-content-center"
    :class="isImage() && isInCollection ? 'py-0' : 'py-2 text-primary'">
      <img v-if="isImage() && isInCollection" :src="media.url.download" alt="" style="max-height: 75px; width: auto;">
      <i v-else :class="'fas fa-' + size + 'x ' + getMediaThumbnail()"></i>
    </div>

    <div v-if="media.type === 'video'" role="button" class="card-img-top py-0">
      <img :src="getMediaThumbnail()" :alt="$t('network.mediaTypes.video')" :style="{ height: isInCollection ? '' : '150px', 'width': '100vw' }"/>
    </div>

    <div v-if="media.type === 'collection'" role="button" class="card-img-top text-primary py-2 d-flex align-items-center justify-content-center">
      <i :class="'fas fa-' + size + 'x ' + getMediaThumbnail()"></i>
    </div>
  </div>
</template>
<script>
import MediaThumbnailGenerator from '@/services/MediaThumbnailGenerator.js';

export default {
  props: {
    media: {
      type: Object,
      default: null,
    },
    isInCollection: {
      type: Boolean,
      default: false,
    },
    size: {
      type: Number,
      default: 5,
    },
  },
  methods: {
    getMediaThumbnail() {
      return new MediaThumbnailGenerator(this.media).getThumbnail();
    },
    isImage() {
      let extension = '';
      if (this.media.url.download !== null) {
        extension = this.media.url.download.split('#').shift().split('?').shift().split('/').pop().split('.').pop().toLowerCase();
      }
      if (extension === 'jpg' || extension === 'jpeg' || extension === 'png' || extension === 'gif') {
        return true;
      } else {
        return false;
      }
    }
  },
};
</script>
